export default {"src":"/_next/static/media/xlsx.06d63684.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};